import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Card, CardContent } from "@/components/ui/card";
import { Landmark, Users, ChevronRight } from "lucide-react";

const options = [
  {
    to: "/transfer/bank",
    icon: Landmark,
    title: "Transfer ke Rekening Bank",
    desc: "Kirim ke 10+ bank di Indonesia. Gratis biaya admin.",
    color: "bg-blue-50 text-primary",
    testid: "transfer-option-bank",
  },
  {
    to: "/transfer/pengguna",
    icon: Users,
    title: "Transfer ke Sesama Pengguna",
    desc: "Instan sampai, cukup dengan alamat email.",
    color: "bg-teal-50 text-[#0FA5A0]",
    testid: "transfer-option-user",
  },
];

export default function TransferHub() {
  return (
    <div className="max-w-2xl mx-auto space-y-6">
      <div>
        <h1 className="font-heading text-2xl font-semibold">Transfer</h1>
        <p className="text-sm text-muted-foreground">Pilih tujuan transfer kamu.</p>
      </div>
      <div className="space-y-3">
        {options.map((op, i) => {
          const Icon = op.icon;
          return (
            <motion.div key={op.to} initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.3, delay: i * 0.07 }}>
              <Link to={op.to} data-testid={op.testid}>
                <Card className="rounded-2xl hover:shadow-[0_10px_30px_rgba(11,18,32,0.08)] hover:border-primary/30 transition-[box-shadow,border-color] duration-200">
                  <CardContent className="p-5 flex items-center gap-4">
                    <span className={`h-12 w-12 rounded-2xl flex items-center justify-center shrink-0 ${op.color}`}>
                      <Icon className="h-6 w-6" />
                    </span>
                    <div className="flex-1 min-w-0">
                      <p className="font-semibold">{op.title}</p>
                      <p className="text-xs text-muted-foreground">{op.desc}</p>
                    </div>
                    <ChevronRight className="h-5 w-5 text-muted-foreground shrink-0" />
                  </CardContent>
                </Card>
              </Link>
            </motion.div>
          );
        })}
      </div>
    </div>
  );
}
